import {
  Activity,
  Smartphone,
  FileText,
  Calendar,
  CreditCard,
  Mail,
  TrendingUp,
  ClipboardList,
} from "lucide-react";

const features = [
  {
    icon: Activity,
    title: "Episodios de Atencion",
    desc: "Organice la recuperacion de sus pacientes por episodios clinicos completos, no por citas aisladas. Vea el progreso real.",
    accent: "emerald",
    span: "md:col-span-2",
  },
  {
    icon: Smartphone,
    title: "Portal del Paciente",
    desc: "Sus pacientes reciben ejercicios y recordatorios directo en su movil. Aumente la adherencia al tratamiento.",
    accent: "amber",
    span: "",
  },
  {
    icon: FileText,
    title: "Historia Clinica Digital",
    desc: "Expedientes completos, seguros y accesibles. Evaluacion inicial, notas de sesion y mediciones de progreso.",
    accent: "emerald",
    span: "",
  },
  {
    icon: Calendar,
    title: "Agenda Inteligente",
    desc: "Vista diaria, semanal y mensual. Cada cita conectada al episodio y expediente del paciente.",
    accent: "emerald",
    span: "",
  },
  {
    icon: ClipboardList,
    title: "Planes de Ejercicio",
    desc: "Prescriba ejercicios con instrucciones claras, frecuencia y repeticiones. Monitoree la adherencia.",
    accent: "amber",
    span: "",
  },
  {
    icon: CreditCard,
    title: "Control de Pagos",
    desc: "Registre pagos manuales, genere estados de cuenta y tenga control financiero de su practica.",
    accent: "emerald",
    span: "",
  },
  {
    icon: Mail,
    title: "Recordatorios por Email",
    desc: "Confirmaciones de cita, recordatorios automaticos y alertas de baja adherencia. Sin depender de WhatsApp.",
    accent: "amber",
    span: "",
  },
  {
    icon: TrendingUp,
    title: "Dashboard Operativo",
    desc: "Metricas clave de su clinica: citas, pacientes activos, episodios e ingresos en un solo vistazo.",
    accent: "emerald",
    span: "md:col-span-2",
  },
];

const accentMap = {
  emerald: {
    iconBg: "bg-emerald-50",
    iconColor: "text-emerald-600",
    hoverBorder: "hover:border-emerald-200",
  },
  amber: {
    iconBg: "bg-amber-50",
    iconColor: "text-amber-600",
    hoverBorder: "hover:border-amber-200",
  },
};

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="py-24 md:py-32 relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-sm font-semibold text-emerald-600 uppercase tracking-widest mb-3">
            Funcionalidades
          </p>
          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-slate-900 tracking-tight mb-4">
            Todo lo que necesita su clinica
          </h2>
          <p className="text-base md:text-lg text-slate-500 leading-relaxed">
            Una plataforma disenada por y para fisioterapeutas. Sin funciones innecesarias, solo lo que realmente usa cada dia.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((f, i) => {
            const colors = accentMap[f.accent];
            return (
              <div
                key={i}
                data-testid={`feature-card-${i}`}
                className={`feature-card bg-white p-7 rounded-2xl border border-slate-100 shadow-sm group ${colors.hoverBorder} ${f.span}`}
              >
                <div
                  className={`w-12 h-12 ${colors.iconBg} rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}
                >
                  <f.icon className={`w-6 h-6 ${colors.iconColor}`} />
                </div>
                <h3 className="font-heading font-semibold text-lg text-slate-800 mb-2">
                  {f.title}
                </h3>
                <p className="text-sm text-slate-500 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
